/**
 * Reusable route parameter constants
 *
 * Use kebab-case for multi-word params as per REST conventions
 * Example: :customer-id instead of :customerId
 */
export const ROUTE_PARAMS = {
  ID: ':id',
  CUSTOMER_ID: ':customer-id',
  USER_ID: ':user-id',
  OU_ID: ':ou-id',
  ROLE_ID: ':role-id',
  PERMISSION_ID: ':permission-id',
  DESIGNATION_ID: ':designation-id',
  COLLECTION_ID: ':collection-id',
} as const;

/**
 * Type helper for extracting param names without the ':' prefix
 * Useful for @Param() decorators
 */
export const PARAM_NAMES = {
  ID: 'id',
  CUSTOMER_ID: 'customer-id',
  USER_ID: 'user-id',
  OU_ID: 'ou-id',
  ROLE_ID: 'role-id',
  PERMISSION_ID: 'permission-id',
  DESIGNATION_ID: 'designation-id',
  COLLECTION_ID: 'collection-id',
} as const;
